import { User, Phone, FileText, Building2 } from 'lucide-react';
import { Badge } from '../../../../../components/ui/badge';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../../../../components/ui/card';
import { formatCnpj, formatCpf, formatPhone } from '../../../../../utils';
import { EntregoRegistration } from '../types';

interface RegistrationsListProps {
  registrations: EntregoRegistration[];
  onSelect: (registration: EntregoRegistration) => void;
}

export function RegistrationsList({
  registrations,
  onSelect,
}: RegistrationsListProps) {
  return (
    <Card className="animate-in slide-in-from-top-4 fade-in-50 duration-300">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="h-5 w-5" />
          Resultados da Busca
        </CardTitle>
        <CardDescription>
          {registrations.length} cadastro(s) encontrado(s). Selecione um para ver detalhes.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {registrations.map((registration) => {
            const documento = registration.cpf
              ? formatCpf(registration.cpf)
              : registration.cnpj
                ? formatCnpj(registration.cnpj)
                : 'N/A';

            return (
              <button
                key={registration.id}
                onClick={() => onSelect(registration)}
                className="w-full text-left p-4 rounded-lg border border-border hover:bg-accent hover:border-accent-foreground/20 transition-colors duration-200"
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex-1 min-w-0 space-y-1">
                    <p className="font-medium text-foreground truncate">
                      {registration.nomeCompleto}
                    </p>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <FileText className="h-3 w-3" />
                        {documento}
                      </span>
                      <span className="flex items-center gap-1">
                        <Phone className="h-3 w-3" />
                        {registration.telefone ? formatPhone(registration.telefone) : 'N/A'}
                      </span>
                      <span className="flex items-center gap-1">
                        <Building2 className="h-3 w-3" />
                        {registration.ops}
                      </span>
                    </div>
                  </div>
                  <Badge
                    variant={registration.ativo ? 'default' : 'destructive'}
                    className="shrink-0"
                  >
                    {registration.ativo ? 'Ativo' : 'Bloqueado'}
                  </Badge>
                </div>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
